module.exports = __webpack_public_path__ + "static/w-desih-7b9491d7d6824b3db2a8d440f34dc107.jpeg";